export const BENCHMARK_INTRO = `
InMarket measures billions of impressions across several verticals, formats and devices. 
These benchmarks are derived from anonymized data and top‑spending advertisers across 
various categories being measured by InMarket. Please note that the results are based 
on average performance metrics and that outcomes may vary by campaign.
`;
